import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { AngularSplitModule, SplitGutterInteractionEvent } from 'angular-split';
import { Subject,takeUntil } from 'rxjs';
import { ReportsComponent } from '../reports.component';
import { LIBRARY_TABS } from '../../../models/enum';
import { REPORT_PROVIDERS } from '../../../services/reports/report-providers';
import { ReportViewComponent } from '../../Solution/Library/report-view/report-view.component';
import { CommonDataService } from '../../../services/common-data.service';
import { CONSTANTS } from '../../../Constants/Constants';

@Component({
  selector: 'app-reports-wrapper',
  imports: [
    AngularSplitModule, 
    ReportsComponent, 
    ReportViewComponent
  ],
  templateUrl: './reports-wrapper.component.html',
  providers: [REPORT_PROVIDERS]
})
export class ReportsWrapperComponent implements OnInit, OnDestroy {
  @Input() showReportView: boolean = true;
  @Input() isReportContentVisible: boolean = true;
  @Input() isReviewTabVisible: boolean = true;
  @Output() unpinReportView = new EventEmitter<LIBRARY_TABS>();
  @Output() closeReportView = new EventEmitter<LIBRARY_TABS>();

  leftPanelWidth: number = CONSTANTS.SPLIT_LIBRARY_WIDTH;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly commonDataService: CommonDataService) {}
  
  ngOnInit(): void {
    this.subscribeToLeftPanelWidthChanges();
  }

  onUnpinReportView(tab: LIBRARY_TABS) {
    this.unpinReportView.emit(tab);
  }

  onCloseReportView(tab: LIBRARY_TABS) {
    this.closeReportView.emit(tab);
  }

  subscribeToLeftPanelWidthChanges() {
    this.commonDataService.leftPanelWidth$.pipe(takeUntil(this.destroy$)).subscribe(width => {
      this.leftPanelWidth = width;
    });
  }

  onReportViewDragEnd(event: SplitGutterInteractionEvent): void {
    const newWidth = Math.round(Number(event.sizes[0]));
    this.commonDataService.setLeftPanelWidth(newWidth);
  }

  get reportsAreaSize(): number {
    return this.showReportView ? CONSTANTS.SPLIT_FULL_WIDTH - this.leftPanelWidth : CONSTANTS.SPLIT_FULL_WIDTH;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}